import { Injectable } from '@angular/core';
import { SentryConfig } from '@env/environment.type';
import {
  browserTracingIntegration,
  captureException,
  init,
  replayIntegration,
} from '@sentry/angular';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  public initialize(config: SentryConfig | null) {
    if (!config) {
      return;
    }

    init({
      dsn: config.dsn,
      release: environment.buildNumber,
      environment: environment.environment ?? undefined,
      integrations: [
        browserTracingIntegration(),
        replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0,
      tracePropagationTargets: config.tracePropagationTargets,
      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  public captureError(err: Error): void {
    captureException(err);
  }
}
